import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import TenantPage from 'layouts/TenantPage';
import { useTranslation } from 'react-i18next';
import { expertiseService } from 'features/cost-analysis/team/expertises/api/expertise.service';
import { AddButton } from 'components/ui';
import { ExpertisesColumns } from '../expertises';

export const ExpertiseList = () => {
  const translationPrefix = 'pages.expertises.list';
  const { t } = useTranslation();

  const columns: GridColDef[] = ExpertisesColumns();

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      menuRight={<AddButton to="new" prefix={translationPrefix} requireTenantAdmin />}>
      <EnhancedDataGrid columns={columns} service={expertiseService} />
    </TenantPage>
  );
};

export default ExpertiseList;
